/**
 * Reasons the inbound reposition failed automatic confirmation and needs accountant verification.
 */
export enum IbRepoVerificationReasonEnum {
  NoDeparture = 'NoDeparture',
  AirportMismatch = 'AirportMismatch',
}
